export const POLLUTION_LIMIT = 1000;

export const POLLUTION_IMPACT = {
    manualAction: 1,
    minerCycle: 1.25,
    smelterCycle: 2,
    fuelUnit: 0.75,
    generatorTick: 0.4,
};

export const accumulatePollution = (current: number, delta: number) => Math.max(0, current + delta);

export const pollutionRatio = (amount: number) => Math.min(1, amount / POLLUTION_LIMIT);
